import Layout from "@/layouts/index.vue";

const routes = [
  {
    path: "/setting",
    meta: { title: "设置" },
    redirect: "/setting/system",
    component: Layout,
    children: [
      {
        path: "/setting/system",
        meta: {
          title: "系统设置",
          icon: "icon-jingdian",
          parentPath: "/setting",
          permissionKey: "setting.system",
          permissionAction: "view",
        },
        component: () => import("@/views/setting/system/index.vue"),
      },
      {
        path: "/setting/mailer",
        meta: {
          title: "邮箱设置",
          icon: "icon-jingdian",
          parentPath: "/setting",
          permissionKey: "setting.mailer",
          permissionAction: "view",
        },
        component: () => import("@/views/setting/mailer/index.vue"),
      },
      {
        path: "/setting/operation-log",
        meta: {
          title: "操作日志",
          icon: "icon-jingdian",
          parentPath: "/setting",
          permissionKey: "setting.operation_log",
          permissionAction: "view",
        },
        component: () => import("@/views/setting/operation-log/index.vue"),
      },
      {
        path: "/setting/wechat",
        meta: {
          title: "微信通知",
          icon: "icon-jingdian",
          parentPath: "/setting",
          permissionKey: "setting.wechat",
          permissionAction: "view",
        },
        component: () => import("@/views/setting/wechat/index.vue"),
      },
    ],
  },
];

export default routes;
